import previewDialog from './previewDialog.vue';

previewDialog.install = function (app) {
  app.component(previewDialog.name, previewDialog)
}

export default previewDialog


//////////////////
// WEBPACK FOOTER
// ./packages/previewDialog/index.js
// module id = null
// module chunks = 